import React, { useEffect } from 'react'
import { Select, Typography, Form, Col } from 'antd'
import { tipologie } from '../assets/constants'
import _ from 'lodash'
import { useHistory } from 'react-router-dom'
import TagManager from 'react-gtm-module'

const { Title, Text } = Typography
const { Option } = Select
const tagManagerArgs = (user_id, tr) => {
  return {
    dataLayer: {
      user_id,
      tr,
      user_type: 'landlord',
      event: 'signup'
    },
    dataLayerName: 'dataLayer'
  }
}

const Tipologia = (props) => {
  const history = useHistory()
  const params = new URLSearchParams(history.location.search)

  useEffect(() => {
    if (params.get('event') == 'signup') {
      const tr = params.get('tr') ? params.get('tr') : null
      const tagManagerArguments = tagManagerArgs(props.formValue.user_idFk, tr)
      TagManager.dataLayer(tagManagerArguments)
    }
  }, [])

  return (
    <Col xs={24} sm={24} md={24} lg={12}>
      <Title>Cosa vuoi affittare?</Title>
      <Form.Item name='tipologia' rules={[{ required: true }]}>
        <Select placeholder='Seleziona una categoria'>
          {_.map(tipologie, (item, index) => (
            <Select.Option key={item} value={String(index)}>
              <Text>{item}</Text>
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </Col>
  )
}

export default Tipologia
